import React, { ComponentPropsWithRef } from 'react'
import { fluidSM, fluidXS } from './fluidFonts'
import { useTheme } from '@mui/material'
type Props = ComponentPropsWithRef<'div'> & {
    title?: string
    subtitle?: string
}
export const WarningMessage = (p: Props) => {
    const { className, title, subtitle, style, ...rest } = p
    const muiTheme = useTheme()
    return (
        <div className="mx-2 text-center my-2" style={style}>
            <div
                className="inline-block border border-solid px-4 py-1 text-xs w-full font-bold"
                style={{
                    ...fluidSM,
                    backgroundColor: muiTheme.palette.error.main,
                    color: muiTheme.palette.error.contrastText,
                    borderColor: muiTheme.palette.error.contrastText,
                }}
            >
                {title}
                {subtitle ? (
                    <>
                        <br />
                        <br />
                        {subtitle}
                    </>
                ) : null}
            </div>
        </div>
    )
}
